// 电脑端入口页

import { useState, useEffect } from 'react'
import RouterConfig from './common/router_config'
import { BrowserRouter as Router } from 'react-router-dom'
import './styles/common.css'
import './App.css'
import 'antd/dist/antd.css'
import Menu from './components/menu/index'
import { ConfigProvider, BackTop, DatePicker } from 'antd'
import { UpCircleOutlined, PoweroffOutlined, UserOutlined, PhoneOutlined } from '@ant-design/icons';
import url from './common/url_config'
import fun from './common/common_fun'
import zhCN from 'antd/es/locale/zh_CN';
import logo_mini from './img/logo_mini.png'
import cookie from 'react-cookies'

function App() {
  let [is_admin_url, set_is_admin_url] = useState(false)

  useEffect(() => {
    set_is_admin_url(window.location.href.indexOf('/admin/') !== -1)
  }, [])

  const log_out = () => {
    let is_confirm = window.confirm('确认退出登陆')
    if (is_confirm) {
      cookie.save('login_username', '', { path: '/' })
      cookie.save('session_key', '', { path: '/' })
      setTimeout(() => {
        window.location.href = '/'
        // window.location.reload()
      }, 300)
    }
  }

  return (
    <div className='main_root'>
      <BackTop>
        <div title='回到顶部' style={{ backgroundColor: '#8d1c22', color: 'white', opacity: 0.5, width: 40, height: 40, textAlign: 'center', lineHeight: '48px' }} ><UpCircleOutlined style={{ fontSize: 25 }} /></div>
      </BackTop>
      <Router>
        <div>
          {is_admin_url && <div style={{ width: 160, position: 'fixed', left: 0, top: 0, height: '100%', backgroundColor: '#001529', zIndex: 1000 }}>
            <div style={{ borderBottom: '4px solid #002a52', color: '#ffffff', marginBottom: 6 }}>
              <a href='/' target='_blank' style={{ textAlign: 'center', height: 50, color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img style={{ width: 32, height: 32, borderRadius: 5 }} src={logo_mini} /><span style={{ fontSize: 15, marginLeft: 10, fontWeight: 'bold' }}>
                  宣怀学院管理
                </span>
              </a>
            </div>
            <Menu />
            <div style={{ color: '#ffffff', marginTop: 30, marginLeft: 10, width: 165 }}>
              <div style={{ marginTop: 5 }}><UserOutlined /> {cookie.load('login_username')}</div>
              <div style={{ marginLeft: 17, fontSize: 13 }}>{cookie.load('login_id') == 1 ? '超级' : ''}{cookie.load('login_role')}</div>
              <div style={{ cursor: 'pointer', marginTop: 5 }} onClick={() => log_out()}><PoweroffOutlined /> 退出登陆</div>
            </div>
          </div>}
          <div style={{ width: '100%', backgroundColor: '', marginTop: 0, overflow: 'auto', }}>
            <div style={is_admin_url ?
              { width: 'calc(100% - 160px)' } :
              { width: '100%', float: 'right', fontSize: 16, lineHeight: '28px' }}
              className={'router'}>
              <ConfigProvider locale={zhCN}><RouterConfig /></ConfigProvider>
            </div>
          </div>
        </div>
      </Router>
    </div>
  );
}

export default App;